import { renderStringToReact, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import ENV from '../../base/env';
import HintPopup from '../../components/HintPopup/HintPopup';
import NumberSlider from '../../components/NumberSlider/NumberSlider';
import './DifficultySelector.scss';

export interface IDifficultySelectorProps {
  difficulty: number;
  maxDifficulty: number;
  limitDifficulty?: number;
  onSelect: (value: number) => void;
}

export const DifficultySelector: React.FC<IDifficultySelectorProps> = ({
  difficulty,
  maxDifficulty,
  limitDifficulty = 0,
  onSelect,
}) => {
  const { t } = useTranslation();

  if (maxDifficulty === 0 || limitDifficulty === 0) {
    // do not render selector if there is nothing to choose
    return null;
  }
  const lockIconSrc = `${ENV.AssetsBaseUrl}/feature/icons/icon-lock.png`;
  const levelLabel = t('Exercise.PreWorkout.Difficulty');
  const style = { '--enabled': maxDifficulty, '--max': limitDifficulty };
  const hideLock = maxDifficulty === limitDifficulty;

  const buttonLabel = t('Exercise.PreWorkout.HintDialogOKLabel');
  const hintPopupTitle = t('Exercise.PreWorkout.HintDialogTitle');
  const hintPopupContent = t('Exercise.PreWorkout.HintContentHtml');

  const contentReactElement = renderStringToReact(hintPopupContent);

  return (
    <div className="difficulty-selector">
      <p className="difficulty-label">
        {levelLabel} {difficulty + 1} / {limitDifficulty + 1}
        <HintPopup title={hintPopupTitle} iconSize={20} okButtonLabel={buttonLabel}>
          {contentReactElement}
        </HintPopup>
      </p>
      <div className="difficulty-slider" style={style as React.CSSProperties}>
        <div className="enabled-difficulty">
          <NumberSlider min={0} max={maxDifficulty} value={difficulty} onChange={onSelect} />
        </div>
        {hideLock ? null : (
          <div className="difficulty-span">
            <img className="difficulty-lock" src={lockIconSrc} alt="max difficulty not yet achieved" />
          </div>
        )}
      </div>
    </div>
  );
};

export default DifficultySelector;
